import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Status } from 'types'
import { TaskOrderAdjuster } from './TaskOrderAdjuster'
import { DateTime } from 'luxon'

interface TaskOrderTabProps {
  date: DateTime
  timeCard?: AdminTimeCard
}

export const TaskOrderTab: FC<TaskOrderTabProps> = ({ date, timeCard }) => {
  const { t } = useTranslation()

  if (!timeCard) {
    return (
      <div className="italic text-center text-neutral-400">
        {t('features.admin.noTimeCard')}
      </div>
    )
  }

  if (timeCard.status === Status.Open) {
    return (
      <div className="p-3 text-sm text-neutral-600 text-center">
        {t('features.admin.taskOrderCanOnlyBeUpdatedAfterSubmission')}
      </div>
    )
  }

  const canModify =
    timeCard.status === Status.Submitted ||
    timeCard.status === Status.Approved ||
    timeCard.correction === true

  // All other cases: show the task order adjuster
  return (
    <TaskOrderAdjuster date={date} timeCard={timeCard} readOnly={!canModify} />
  )
}
